export default "__VITE_ASSET__3d5c2ea2__"